module.exports = __webpack_public_path__ + "static/media/Cold Canvassing.c0a6be4e.pdf";